import { useChangeLanguage } from 'remix-i18next/react';
import { useShopStore } from '~/stores/shop';

import isBrowser from '~/utils/isBrowser';

const SUPPORTED_LANG: Record<string, string> = {
  es: 'es',
  'zh-CN': 'cn',
  'zh-TW': 'cn',
};

export const useInitializeLanguage = ({ locale }: { locale: string | null }) => {
  const setShopifyLocale = useShopStore((state) => state.setShopifyLocale);

  let initLang = SUPPORTED_LANG?.[locale ?? ''] ?? 'en';
  setShopifyLocale(initLang);

  if (isBrowser()) {
    const localLang = window.localStorage.getItem('i18nextLng') ?? '';
    initLang = localLang || initLang;
  }

  useChangeLanguage(initLang);
};
